/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_CityInputs */

const cs_form_city = /** @type {(inputs: Form_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Město`)
};

const en_form_city = /** @type {(inputs: Form_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Form_CityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_city = /** @type {((inputs?: Form_CityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_CityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_city(inputs)
	return cs_form_city(inputs)
});